/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".callout_ad5629e1 .ms-Suggestions-itemButton{padding:0;border:none}.callout_ad5629e1 .ms-Suggestions{min-width:300px}" }]);
export var callout = "callout_ad5629e1";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map